<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"
                placeholder="商品编号、商品名称、供应商"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadGood'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="goodsList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="编号" prop="code"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="类型" prop="typeCode">
        <template #default="{row}">
          {{ row.typeCode | valueName('GOODS_TYPE') }}
        </template>
      </el-table-column>
      <el-table-column label="单价（元）" prop="price"></el-table-column>
      <el-table-column label="单位" prop="unit"></el-table-column>
      <el-table-column label="供应商">
        <template #default="{row}">
          {{ row.supplierCode | valueName('SUPPLIER') }}
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 150 : 160" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
          <span v-else>操作</span>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="detail(row)" size="mini">详情</el-button>
          <el-button v-if="!readOnly" type="text" @click="edit(row)" size="mini">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteGoods(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <edit-goods-dialog :visible.sync="dialog.show"
                       :goods="dialog.goods"
                       :read-only="dialog.readOnly">
    </edit-goods-dialog>
  </div>
</template>

<script>
import EditGoodsDialog from '@/views/goods/EditGoodsDialog'
import { Goods } from '@/store/objdef/objectDef'
import { valueName } from '@/utils/filters'
import authority from '@/utils/authority'

export default {
  name: 'GoodsList',
  components: { EditGoodsDialog },
  data () {
    return {
      loading: false,
      searchText: null,
      dialog: {
        show: false,
        readOnly: true,
        goods: new Goods()
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$store.dispatch('goods/all').finally(() => {
        this.loading = false
      })
    },
    add () {
      this.dialog.goods = new Goods()
      this.dialog.show = true
    },
    detail (goods) {
      this.dialog.readOnly = true
      this.dialog.goods = this.$_.cloneDeep(goods)
      this.dialog.show = true
    },
    edit (goods) {
      this.dialog.readOnly = false
      this.dialog.goods = this.$_.cloneDeep(goods)
      this.dialog.show = true
    },
    deleteGoods (goods) {
      this.$confirm(`确认删除商品【${goods.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('goods/delete', goods.id).then(() => {
          this.$message.success('删除成功!')
        })
      }).catch(() => {
      })
    },
    exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      }
  },
  computed: {
    exportUrl () {
        return this.$baseUrl + 'api/downloadGoodTemplate'
      },
    goodsList () {
      const list = this.$store.state.goods.goodsList
      if (!this.searchText) return list

      return list.filter(goods => goods.name.indexOf(this.searchText) !== -1 ||
        goods.code.indexOf(this.searchText) !== -1 ||
        valueName(goods.supplierCode, 'SUPPLIER').indexOf(this.searchText) !== -1)
    },
    readOnly () {
      return !this.$hasPermission(authority.WAREHOUSE)
    },
    addable () {
      return this.$hasPermission(authority.WAREHOUSE)
    },
    deletable () {
      return this.$hasPermission(authority.WAREHOUSE)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}
</style>
